// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.85.0-beta.af24e1039',
  revision: 'af24e1039',
  branch: 'develop',
  date: 'Thu, 26 Feb 2026 17:12:23 GMT'
};